import styled from 'styled-components';

const TrackingMessage = styled.div`
  display: ${props => (!props.enabled ? 'inline' : 'none')};
  position: absolute;
  left: ${props => props.position.left + 15}px;
  top: ${props => props.position.top + 10}px;
  z-index: 100;
  background-color:#505050;
  color : #fff;
  padding: 10px 10px;
  width : 140px;
  border-radius:5px;

  @media only screen and (max-width: 991.92px) {
    display: none;
  }
`;

export default TrackingMessage;
